import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFileSettingsForm } from './useFileSettingsForm';
import { RootState } from '../../store';
import { updateFileSettings } from '../../store/settings/actions';
import { SettingsPageForm } from '../Settings/SettingsPageForm';
import { ModuleContainer } from '../Settings/ModuleContainer';
import { SetupModulePageDescription } from '../Settings/ModuleManagementPage/SetupModule';
import SetupModuleBreadCrumbs from '../Settings/ModuleManagementPage/SetupModule/SetupModuleBreadCrumbs';
import { useEditingModule } from '../Settings/ModuleManagementPage/SetupModule/useEditingModule';
import history from '../../history';
import {
  ADD_APP_PAGE,
  ADD_MODULE_PAGE,
  APP_SETUP_PAGE,
  FileSettings,
  MODULE_MANAGEMENT_PAGE,
  ModuleSettingsItem,
} from '../../constants';
import { FlagsContext } from '../../context';

const FileSettingsPage = () => {
  const dispatch = useDispatch();
  const { EnableAppSetupImprovements } = useContext(FlagsContext);
  const filesModule = useEditingModule();
  const fileSettings = useSelector(
    (state: RootState) => state.settings.fileSettings,
  );

  const initialValues = React.useMemo(
    () => ({
      label: filesModule?.label || '',
      icon: filesModule?.icon || '',
      alwaysOnVisibility: Boolean(fileSettings?.alwaysOnVisibility),
      clientFileDeleteDisabled: Boolean(fileSettings?.clientFileDeleteDisabled),
      clientFileAddDisabled: Boolean(fileSettings?.clientFileAddDisabled),
      clientFolderUpdateDisabled: Boolean(
        fileSettings?.clientFolderUpdateDisabled,
      ),
    }),
    [fileSettings, filesModule],
  );

  /**
   * Save file settings
   */
  const onSave = async (values: FileSettings & ModuleSettingsItem) => {
    dispatch(
      updateFileSettings({
        fileSettings: values,
        currentFileModule: filesModule,
      }),
    );

    if (EnableAppSetupImprovements) {
      history.push(APP_SETUP_PAGE.path);
    } else {
      history.push(MODULE_MANAGEMENT_PAGE.path);
    }
  };

  const handleCancel = () => {
    if (EnableAppSetupImprovements) {
      history.push(ADD_APP_PAGE.path);
    } else {
      history.push(ADD_MODULE_PAGE.path);
    }
  };

  return (
    <ModuleContainer description={<SetupModulePageDescription />}>
      <SettingsPageForm
        BreadcrumbsComponent={<SetupModuleBreadCrumbs />}
        useFormHook={useFileSettingsForm}
        initialFormValue={initialValues}
        handleSave={onSave}
        actionLabel={filesModule?.disabled ? 'Enable' : 'Save'}
        shouldShowPageAction={filesModule?.disabled}
        // for enabled file module we just reset the form changes on "Cancel" click
        // and if there are no changes in form we don't show the form actions
        handleCancel={filesModule?.disabled ? handleCancel : undefined}
      />
    </ModuleContainer>
  );
};

export default FileSettingsPage;
